import { DeliveryOrderBatchListPage } from "@/features/delivery-order-batch/pages/DeliveryOrderBatchListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/delivery-order-batch/")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({ permissions: ["delivery_order.batch_generate"] })
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: DeliveryOrderBatchListPage,
});
